import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getArticlesFromApi } from "../../../constants/post";
import { getImageUrl } from "../../../utils/imageUtils";
import style from "../Blog/Blog.module.css";

export const Blog = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      const data = await getArticlesFromApi();

      // Aquí haces la transformación que quieras
      const mappedArticles = data.map((item, index) => {
        return {
          id: item.id || `article_${index + 1}`,
          title: item.title || "",
          description: item.description || "",
          largeDescription: item.content?.replace(/<[^>]+>/g, "") || "",
          image: item.imagesTitle || item.imageUrl || "",
          content: item.content
        };
      });
      // console.log("datos", mappedArticles);

      setArticles(mappedArticles);
    };

    fetchArticles();
  }, []);


  return (
    <div className={style.contenedorFondo}>
      <h3 className={style.tituloNovedad}>Vogue Tips</h3>
      <div className="btn-blog">
        <Link className="verTodo" to="/blog">
          Ver todos los artículos
        </Link>
      </div>
      <div className={style.contenedorCads}>
        {articles.slice(0, 3).map((article, index) => (
          <div key={index} className={style.cardsVogueTipsHome}>
            <div className={style.contenedorTitulo}>
              <h4 className={style.tituloCards}>{article.title}</h4>
            </div>
            <div className={style.contenedorImg}>
              <img
                className={style.imagen}
                src={getImageUrl(article.image, 'medium')}
                alt={`foto ilustrativa del producto ${article.title}`}
              />
            </div>
            <div className={style.contenedorDescripcion}>
              <p className={style.descripcion}>{article.description}</p>
            </div>
            <Link
              to="/detalle-blog"
              className={style.contenedorBtn}
              state={{ article }}
            >
              Leer más
            </Link>
          </div>
        ))}
      </div>

  

    </div>
  );
};
